// import React, { useEffect, useState } from "react";
// import { Icon } from "@iconify/react";
// import Swal from "sweetalert2";
// import Select from "react-select";
// import indiaLocations from "../data/indiaLocations.json";
// import { fetchData } from "../helper/api.interceptor";

// const EditSolarPanelModal = ({ show, onClose, editData, refreshList }) => {
//     const [formData, setFormData] = useState({
//         name: "",
//         capacity: "",
//         price: "",
//         type: "",
//         state: "",
//         cities: [],
//         image: null,
//     });

//     const [availableCities, setAvailableCities] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // ✅ Load data if editing
//     useEffect(() => {
//         const fetchSolarPanel = async () => {
//             if (editData?.id) {
//                 try {
//                     const res = await fetchData.get(`/solar/by-id?id=${editData.id}`);
//                     const data = res.result;

//                     const selectedState = data.state || "";
//                     const stateObj = indiaLocations.find((s) => s.state === selectedState);
//                     const districtList = stateObj
//                         ? stateObj.districts.map((d) => d.district)
//                         : [];

//                     setAvailableCities(districtList);

//                     setFormData({
//                         name: data.name || "",
//                         capacity: data.capacity || "",
//                         price: data.price || "",
//                         type: data.type || "",
//                         state: selectedState,
//                         cities:
//                             data.cities?.map((c) => ({
//                                 label: c,
//                                 value: c,
//                             })) || [],
//                         image: null,
//                     });
//                 } catch (err) {
//                     console.error("Failed to fetch solar panel", err);
//                     Swal.fire("Error", "Failed to load solar panel data", "error");
//                 }
//             } else {
//                 // Reset form
//                 setFormData({
//                     name: "",
//                     capacity: "",
//                     price: "",
//                     type: "",
//                     state: "",
//                     cities: [],
//                     image: null,
//                 });
//                 setAvailableCities([]);
//             }
//         };

//         fetchSolarPanel();
//     }, [editData]);

//     // ✅ Update available cities when state changes
//     useEffect(() => {
//         if (formData.state) {
//             const stateObj = indiaLocations.find((s) => s.state === formData.state);
//             if (stateObj && Array.isArray(stateObj.districts)) {
//                 setAvailableCities(stateObj.districts.map((d) => d.district));
//             } else {
//                 setAvailableCities([]);
//             }

//             if (!formData.cities.length) {
//                 setFormData((prev) => ({ ...prev, cities: [] }));
//             }
//         } else {
//             setAvailableCities([]);
//         }
//     }, [formData.state]);

//     // ✅ Handle normal inputs
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));
//     };

//     // ✅ Handle image upload
//     const handleImageChange = (e) => {
//         setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
//     };

//     // ✅ Submit handler
//     const handleSubmit = async () => {
//         const payload = new FormData();
//         payload.append("name", formData.name);
//         payload.append("capacity", formData.capacity);
//         payload.append("price", formData.price);
//         payload.append("type", formData.type);
//         payload.append("state", formData.state);

//         // ✅ Append cities properly
//         formData.cities.forEach((c) => payload.append("cities[]", c.value));

//         if (formData.image) payload.append("image", formData.image);

//         setLoading(true);
//         try {
//             if (editData && editData.id) {
//                 await fetchData.post(`/solar/update?id=${editData.id}`, payload);
//                 Swal.fire("Updated!", "Solar panel updated successfully", "success");
//             } else {
//                 await fetchData.post("/solar/add", payload);
//                 Swal.fire("Added!", "Solar panel added successfully", "success");
//             }

//             onClose();
//             refreshList();
//         } catch (err) {
//             Swal.fire("Error", "Something went wrong", "error");
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (!show) return null;

//     return (
//         <div className="modal fade show d-block" tabIndex="-1">
//             <div className="modal-dialog modal-lg modal-dialog-centered">
//                 <div className="modal-content">
//                     <div className="modal-header">
//                         <h5 className="modal-title">
//                             {editData ? "Edit Solar Panel" : "Add Solar Panel"}
//                         </h5>
//                         <button type="button" className="btn-close" onClick={onClose}></button>
//                     </div>

//                     <div className="modal-body">
//                         <div className="d-flex flex-column gap-3">
//                             {/* Name */}
//                             <div className="flex-fill">
//                                 <label className="form-label">Name *</label>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     name="name"
//                                     value={formData.name}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>

//                             {/* Capacity */}
//                             <div className="flex-fill">
//                                 <label className="form-label">Capacity (W) *</label>
//                                 <input
//                                     type="number"
//                                     className="form-control"
//                                     name="capacity"
//                                     value={formData.capacity}
//                                     onChange={handleInputChange}
//                                     placeholder="e.g. 550"
//                                 />
//                             </div>

//                             {/* Price */}
//                             <div className="flex-fill">
//                                 <label className="form-label">Price (₹) *</label>
//                                 <input
//                                     type="number"
//                                     className="form-control"
//                                     name="price"
//                                     value={formData.price}
//                                     onChange={handleInputChange}
//                                 />
//                             </div>

//                             {/* Type */}
//                             <div className="flex-fill">
//                                 <label className="form-label">Type *</label>
//                                 <select
//                                     className="form-select"
//                                     name="type"
//                                     value={formData.type}
//                                     onChange={handleInputChange}
//                                 >
//                                     <option value="">Select Type</option>
//                                     <option value="DCR">DCR</option>
//                                     <option value="Non-DCR">Non-DCR</option>
//                                 </select>
//                             </div>

//                             {/* State */}
//                             <div className="flex-fill" style={{ minWidth: "200px" }}>
//                                 <label className="form-label">State</label>
//                                 <Select
//                                     options={indiaLocations.map((s) => ({
//                                         label: s.state,
//                                         value: s.state,
//                                     }))}
//                                     value={
//                                         formData.state
//                                             ? { label: formData.state, value: formData.state }
//                                             : null
//                                     }
//                                     onChange={(selected) =>
//                                         setFormData((prev) => ({
//                                             ...prev,
//                                             state: selected?.value || "",
//                                             cities: [],
//                                         }))
//                                     }
//                                     placeholder="Select State"
//                                     isClearable
//                                 />
//                             </div>

//                             {/* Cities */}
//                             <div className="flex-fill" style={{ minWidth: "250px" }}>
//                                 <label className="form-label">Cities</label>
//                                 <Select
//                                     isMulti
//                                     options={availableCities.map((c) => ({
//                                         label: c,
//                                         value: c,
//                                     }))}
//                                     value={formData.cities}
//                                     onChange={(selected) =>
//                                         setFormData((prev) => ({
//                                             ...prev,
//                                             cities: selected || [],
//                                         }))
//                                     }
//                                     placeholder={
//                                         formData.state ? "Select cities" : "Select state first"
//                                     }
//                                     isDisabled={!availableCities.length}
//                                 />
//                             </div>

//                             {/* Image */}
//                             <div className="flex-fill" style={{ minWidth: "200px" }}>
//                                 <label className="form-label">Panel Image</label>
//                                 <input
//                                     type="file"
//                                     className="form-control"
//                                     onChange={handleImageChange}
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     <div className="modal-footer">
//                         <button className="btn btn-secondary" onClick={onClose}>
//                             Cancel
//                         </button>
//                         <button
//                             className="btn btn-primary"
//                             onClick={handleSubmit}
//                             disabled={loading}
//                         >
//                             {loading ? (
//                                 <>
//                                     <Icon icon="eos-icons:loading" className="spinner me-2" />
//                                     {editData ? "Updating..." : "Adding..."}
//                                 </>
//                             ) : (
//                                 editData ? "Update" : "Add"
//                             )}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EditSolarPanelModal;
import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import Select from "react-select";
import indiaLocations from "../data/indiaLocations.json";
import { fetchData } from "../helper/api.interceptor";

const EditSolarPanelModal = ({ show, onClose, editData, refreshList }) => {
    const [formData, setFormData] = useState({
        name: "",
        capacity: "",
        price: "",
        type: "",
        category: "",
        state: "",
        cities: [],
        image: null,
    });

    const [availableCities, setAvailableCities] = useState([]);
    const [loading, setLoading] = useState(false);

    // ✅ Load data if editing
    useEffect(() => {
        const fetchSolarPanel = async () => {
            if (editData?.id) {
                try {
                    const res = await fetchData.get(`/solar/by-id?id=${editData.id}`);
                    const data = res.result;

                    const selectedState = data.state || "";
                    const stateObj = indiaLocations.find((s) => s.state === selectedState);
                    const districtList = stateObj
                        ? stateObj.districts.map((d) => d.district)
                        : [];

                    setAvailableCities(districtList);

                    setFormData({
                        name: data.name || "",
                        capacity: data.capacity || "",
                        price: data.price || "",
                        type: data.type || "",
                        category: data.Category || data.category || "",
                        state: selectedState,
                        cities:
                            data.cities?.map((c) => ({
                                label: c,
                                value: c,
                            })) || [],
                        image: null,
                    });
                } catch (err) {
                    console.error("Failed to fetch solar panel", err);
                    Swal.fire("Error", "Failed to load solar panel data", "error");
                }
            } else {
                // Reset form
                setFormData({
                    name: "",
                    capacity: "",
                    price: "",
                    type: "",
                    category: "",
                    state: "",
                    cities: [],
                    image: null,
                });
                setAvailableCities([]);
            }
        };

        fetchSolarPanel();
    }, [editData]);

    // ✅ Update available cities when state changes
    useEffect(() => {
        if (formData.state) {
            const stateObj = indiaLocations.find((s) => s.state === formData.state);
            if (stateObj && Array.isArray(stateObj.districts)) {
                setAvailableCities(stateObj.districts.map((d) => d.district));
            } else {
                setAvailableCities([]);
            }

            if (!formData.cities.length) {
                setFormData((prev) => ({ ...prev, cities: [] }));
            }
        } else {
            setAvailableCities([]);
        }
    }, [formData.state]);

    // ✅ Handle normal inputs
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ✅ Handle image upload
    const handleImageChange = (e) => {
        setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
    };

    // ✅ Submit handler
    const handleSubmit = async () => {
        const payload = new FormData();
        payload.append("name", formData.name);
        payload.append("capacity", formData.capacity);
        payload.append("price", formData.price);
        payload.append("type", formData.type);
        payload.append("category", formData.category);
        payload.append("state", formData.state);

        // ✅ Append cities properly
        formData.cities.forEach((c) => payload.append("cities[]", c.value));

        if (formData.image) payload.append("image", formData.image);

        setLoading(true);
        try {
            if (editData && editData.id) {
                await fetchData.post(`/solar/update?id=${editData.id}`, payload);
                Swal.fire("Updated!", "Solar panel updated successfully", "success");
            } else {
                await fetchData.post("/solar/add", payload);
                Swal.fire("Added!", "Solar panel added successfully", "success");
            }

            onClose();
            refreshList();
        } catch (err) {
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {editData ? "Edit Solar Panel" : "Add Solar Panel"}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body">
                        <div className="d-flex flex-column gap-3">
                            {/* Name */}
                            <div className="flex-fill">
                                <label className="form-label">Name *</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                />
                            </div>

                            {/* Capacity */}
                            <div className="flex-fill">
                                <label className="form-label">Capacity (W) *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="capacity"
                                    value={formData.capacity}
                                    onChange={handleInputChange}
                                    placeholder="e.g. 550"
                                />
                            </div>

                            {/* Price */}
                            <div className="flex-fill">
                                <label className="form-label">Price (₹) *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="price"
                                    value={formData.price}
                                    onChange={handleInputChange}
                                />
                            </div>

                            {/* Type */}
                            <div className="flex-fill">
                                <label className="form-label">Type *</label>
                                <select
                                    className="form-select"
                                    name="type"
                                    value={formData.type}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select Type</option>
                                    <option value="DCR">DCR</option>
                                    <option value="Non-DCR">Non-DCR</option>
                                </select>
                            </div>

                            {/* Category */}
                            <div className="flex-fill">
                                <label className="form-label">Category *</label>
                                <select
                                    className="form-select"
                                    name="category"
                                    value={formData.category}  // ✅ FIXED: lowercase key
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select Category</option>
                                    <option value="Silver">Silver</option>
                                    <option value="Gold">Gold</option>
                                    <option value="Platinum">Platinum</option>
                                </select>
                            </div>

                            {/* State */}
                            <div className="flex-fill" style={{ minWidth: "200px" }}>
                                <label className="form-label">State</label>
                                <Select
                                    options={indiaLocations.map((s) => ({
                                        label: s.state,
                                        value: s.state,
                                    }))}
                                    value={
                                        formData.state
                                            ? { label: formData.state, value: formData.state }
                                            : null
                                    }
                                    onChange={(selected) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            state: selected?.value || "",
                                            cities: [],
                                        }))
                                    }
                                    placeholder="Select State"
                                    isClearable
                                />
                            </div>

                            {/* Cities */}
                            <div className="flex-fill" style={{ minWidth: "250px" }}>
                                <label className="form-label">Cities</label>
                                <Select
                                    isMulti
                                    options={availableCities.map((c) => ({
                                        label: c,
                                        value: c,
                                    }))}
                                    value={formData.cities}
                                    onChange={(selected) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            cities: selected || [],
                                        }))
                                    }
                                    placeholder={
                                        formData.state ? "Select cities" : "Select state first"
                                    }
                                    isDisabled={!availableCities.length}
                                />
                            </div>

                            {/* Image */}
                            <div className="flex-fill" style={{ minWidth: "200px" }}>
                                <label className="form-label">Panel Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={handleImageChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Icon icon="eos-icons:loading" className="spinner me-2" />
                                    {editData ? "Updating..." : "Adding..."}
                                </>
                            ) : (
                                editData ? "Update" : "Add"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditSolarPanelModal;
